import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Table } from 'reactstrap';
import * as actions from '../store/actions';
import { Link } from 'react-router-dom';
import { BASE_URL } from '../common/constants';
import Button from '@material-ui/core/Button';
import { Container, Row } from 'reactstrap';
import FormModal from '../components/FormModal';
import Form from '../components/Form';

const styles = theme => ({
  root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setTitle: (m) => dispatch(actions.base.setTitle(m)),
    updateKostenOptions: () => dispatch(actions.base.updateKostenOptionsSaga()),
  }
}


const mapStateToProps = (state) => {
  return {
    title: state.base.title,
    kostenOptions: state.base.kostenOptions,
    config: state.auth.config,
  }
}


class Kosten extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      kosten: false,
      kost: false,
      modal: false,
    }
  }

  componentDidMount() {
    this.props.updateKostenOptions();
    axios.get(BASE_URL + 'kosten', this.props.config).then(res => {
      this.setState({ loading: false, kosten: res.data, });
    });
    this.props.setTitle("Kostenarten")
  }

  formChange = event => {
    let m = this.state.kost
    m[event.target.name] = event.target.value;
    this.setState({ kost: m });
  }

  closeModal = () => {
    this.setState({modal:false});
  }

  reload = () => {
    axios.get(BASE_URL + 'kosten').then(res => {
      this.setState({ loading: false, kosten: res.data, });
    });
  }

  render() {
    return <Container><Row>
      { this.state.loading ? <h2>Daten werden geladen...</h2> :   <Row>
            <Button color="primary"
                onClick={ () => { this.setState({modal:true, kost: {url: 'new'}}) } }
              >Neue Kostenart anlegen</Button>
            <Table>
              <thead>
                <tr>
                  <th>id</th>
                  <th>art</th>
                  <th>bezeichnung</th>
                  <th>betrag</th>
                  <th>mitglieder</th>
                  <th>institutionen</th>
                </tr>
              </thead>
              <tbody>
                {this.state.kosten.results.map((v,i) => (<tr key={v.id}>
                    <th scope="row" onClick={() => {this.setState({kost: v, modal: true}) } }>{v.id}</th>
                    <td>{v.art}</td>
                    <td>{v.bezeichnung}</td>
                    <td>{v.betrag}</td>
                    <td>
                      <Link to={'/mitglieder/?key=kostenart__art&value='+v.art}>{v.vereinsmitglied_count} ({v.vereinsmitglied_inactive_count})</Link>
                    </td>
                    <td>
                      <Link to={'/institutionen/?key=kostenart__art&value='+v.art}>{v.institution_count} ({v.institution_inactive_count})</Link>
                    </td>
                  </tr>)
                )}
              </tbody>
            </Table>
        </Row>
      }
      </Row>
      <FormModal open={this.state.modal} title="Edit Kostenart" handleClose={this.closeModal}>
        <Form values={this.state.kost}
          options={this.props.kostenOptions}
          handleCancel={this.closeModal}
          postUrl={BASE_URL+'kosten/'}
          onChange={this.formChange} 
          postSave={this.reload} 
          handleDelete={this.reload} />          
      </FormModal>
    </Container>
  }
}

Kosten.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Kosten))
